<template>
  <div id="app">
    <EnerChart msg="Welcome to EnerCharts"/>
  </div>
</template>

<script>
import EnerChart from './components/EnerChart.vue'

export default {
  name: 'App',
  components: {
    EnerChart,
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
